import React from 'react';
import LikeHeart from '../../../shared/components/like_heart';

const TabBar = ({
  likeProps,
  sponsors,
  setTab,
  tab,
  openForSponsorship,
  infoRef,
  guestsRef,
  sponsorsRef,
  soldOut,
  signedIn
}) => {
  const { initLikeState, heartFilledPath, heartOutlinePath, id, type } =
    likeProps;

  const setBadge = () => {
    if (openForSponsorship && !soldOut) {
      return (
        <span className="badge open">OPEN</span>
      );
    } else if (soldOut) {
      return (
        <span className="badge sold-out">SOLD OUT</span>
      );
    }
  };

  const handleClick = (tab) => {
    let value = 0;
    if (tab === 'info') {
      value +=
        infoRef.current.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top: value, behavior: 'smooth' });
      setTab('info');
    } else if (tab === 'guests') {
      value +=
        guestsRef.current.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: value, behavior: 'smooth' });
      setTab('guests');
    } else if (tab === 'sponsors') {
      value +=
        sponsorsRef.current.getBoundingClientRect().top + window.scrollY - 81;
      window.scrollTo({ top: value, behavior: 'smooth' });
      setTab('sponsors');
    }
  };

  return (
    <div className="nav-container-event-like">
      <ul className="nav nav-tabs t4 w3" id="nav-tabs" role="tablist">
        <li className={`nav-item ${tab === 'info' ? 'active' : ''}`}>
          <a
            className="nav-link nostyle pl-25 pr-25"
            onClick={() => handleClick('info')}
          >
            Information
          </a>
        </li>
        <li className={`nav-item ${tab === 'guests' ? 'active' : ''}`}>
          <a
            className="nav-link nostyle pl-25 pr-25"
            onClick={() => handleClick('guests')}
          >
            Guests
          </a>
        </li>
        {sponsors.length > 0 && (
          <li className={`nav-item ${tab === 'sponsors' ? 'active' : ''}`}>
            <a
              className="nav-link nostyle pl-25 pr-25"
              onClick={() => handleClick('sponsors')}
            >
              Sponsors
              {/* {setBadge()} */}
            </a>
          </li>
        )}
      </ul>
      {signedIn && <LikeHeart
        initLikeState={initLikeState}
        heartFilledPath={heartFilledPath}
        heartOutlinePath={heartOutlinePath}
        id={id}
        type={type}
      />}
    </div>
  );
};

export default TabBar;
